module.exports = __webpack_public_path__ + "static/media/settings1.3e635650.svg";